import React from 'react';
import Services from './../services/services';
import Steps from './../basics/Steps';
import ShopHeader from './ShopHeader';
import Payments from './../services/payments';

import {
  BrowserRouter as Router, Route, Routes, Link
} from "react-router-dom";

import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

const Summary = () => {

  function sleep(ms:number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

  let {id} = useParams();

  const payment = new Payments();

  const [paymentButton, setPaymentButton] = useState(<div></div>);

  const [timeLeft, setTimeLeft] = useState(15); // 15 seconds

  const [state, setState] = useState({
    firstname: '',
    lastname: '',
    is_paid: '',
    icon: 'fa-2xl mb-3 fas fa-spinner fa-pulse text-primary'
  })

  useEffect(()=>{

    console.log('Effect used '+id);

    console.log(state.is_paid)



    sleep(15000).then(() => {
      if( id !== null){

        payment.checkPayment(id).then((e) => {

          let newState = {...state};

          newState['firstname'] = e.firstname
          newState['lastname'] = e.lastname
          if( e.is_paid == true ){
            newState['is_paid'] = 'Zaplaceno'
            newState['icon'] = 'text-success fa-2xl mb-3 fa-solid fa-circle-check'
            setPaymentButton(<div></div>)
          }else{
            newState['is_paid'] = 'Platba neproběhla - Čeká na zaplacení'
            newState['icon'] = 'text-danger fa-2xl mb-3 fa-solid fa-circle-exclamation'

            let returnUrl = 'http://www.balonklub.cz/app/summary/'+id

            payment.getPayment( id, returnUrl ).then((e) => {
              setPaymentButton(<form action={e.return_url} method="post" id="gopay-payment-button">
                <button className="btn btn-lg rounded-pill btn-primary w-100 my-3" name="pay" type="submit">Zaplatit</button>
                <script type="text/javascript" src="https://gw.sandbox.gopay.com/gp-gw/js/embed.js"></script>
              </form>)

            })

          }

          setState(newState)

        })

      }})

  }, [])

  useEffect(() => {
    // Exit early when no time left
    if (timeLeft === 0) return;

    // Save intervalId to clear the interval later
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    // Clear interval on component unmount
    return () => clearInterval(intervalId);
  }, [timeLeft]);

  const steps = [

    {'name':'Košík', 'link':'', 'active': true},
    {'name':'Pokladna','link': '', 'active': true},
    {'name':'Shrnutí','link': '', 'active': false},

  ];

  return (

    <div>
      <ShopHeader title="Shrnutí" subtitle="stav Vaší objednávky" image="https://balloonadventures.cz/wp-content/uploads/2019/07/IMG_0581.jpg"/>

      <div className="container">

        <Steps links={steps} />

        <div className="d-flex flex-column align-items-center my-5 py-5">
            <i className={state.icon}></i>
            <div className="fs-4 montserrat mt-3">
              {timeLeft > 0 ? (
                <div>
                  <div className='text-center'>Vyčkejte na ověření platby</div>
                  <div className='text-center'>{timeLeft}</div>
                </div>
              ) : (
                <span>Objednávka</span>
              )}
            </div>
            <div className="fs-2 montserrat fw-bold">{state.firstname} {state.lastname}</div>
            <div className="fs-4 montserrat"></div>
            <div className="fs-4 montserrat mb-2">{state.is_paid}</div>
            {paymentButton}
        </div>
      </div>
    </div>
  );
}

export default Summary;
